/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SalesTaxRatesRestService } from '@gh/builder-shared-data';
import { InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { SalesTaxRate } from './estimating-sales-tax-rates-tab.model';

export interface EstimatingSalesTaxRateDetailsDialogConfig {
  id?: ID;
}

@Injectable()
export class EstimatingSalesTaxRatesTabBusinessService implements InitViewService, InitDialogViewService<EstimatingSalesTaxRateDetailsDialogConfig> {

  constructor(private restService: SalesTaxRatesRestService,
              private gridLayoutService: GridLayoutService) {
  }

  /**
   * @returns {{gridLayout: Observable<GridLayout>}}
   */
  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('salesTaxRates'),
    };
  }

  /**
   * @param route
   * @returns {*} Init Values
   */
  initDialogView(route: DialogRouteSnapshot<EstimatingSalesTaxRateDetailsDialogConfig>): any {
    return {
      salesTaxRate: route.input.id ? this.get(<ID>route.input.id) : { isDefault: false },
    };
  }

  /**
   * Creates data source for list in Grid Component
   * @returns {SlicedDataSource<SalesTaxRate>}
   */
  findAllAsDataSource(): SlicedDataSource<SalesTaxRate> {
    return this.restService.findAllAsDataSource();
  }

  /**
   * @param id
   * @returns {Observable<SalesTaxRateDto>}
   */
  get(id: ID): Observable<SalesTaxRate> {
    return this.restService.get(id);
  }

  /**
   * Updates of create new Sales Tax Rate
   * @param salesTaxRate
   * @returns {any}
   */
  save(salesTaxRate: SalesTaxRate): Observable<SalesTaxRate> {
    if (salesTaxRate.id) {
      return this.restService.update(salesTaxRate);
    }
    return this.restService.create(salesTaxRate);
  }

}
